import axios from "axios";
import {
  ubiqPath,
  contractPath,
  mainPath,
  RequestMethodTypes,
  TOKEN_STORAGE,
} from "./constants";
import { logError } from "../../utils/errors";

const parsedToken = () => JSON.parse(localStorage.getItem(TOKEN_STORAGE));

const getAccessToken = () => parsedToken()?.accessToken?.accessToken || null;

export const getBearerToken = () => `Bearer ${getAccessToken()}`;

export const getHeaders = (token, isPDF) => {
  const accessToken = getBearerToken() || `Bearer ${token}`;
  const contentType = "application/json";
  const contentTypePDF = "application/pdf";

  return {
    "Content-Type": contentType,
    Accept: isPDF ? contentTypePDF : contentType,
    Authorization: accessToken,
  };
};

export const getUrl = (url, isContractURL) =>
  `${isContractURL ? contractPath : mainPath}/${url}`;

export const getUBIQUrl = (url) => `${ubiqPath}/${url}`;

export const fetchWrapper = async ({
  method = RequestMethodTypes.GET,
  url = "",
  data = null,
  responseType,
  isContractURL = false,
  isUBIQ = false,
  isPDF = false,
  isErrorPage = true,
  token = null,
}) => {
  try {
    let res = null;

    if (
      ([
        RequestMethodTypes.POST,
        RequestMethodTypes.PUT,
        RequestMethodTypes.DELETE,
      ].includes(method) &&
        data) ||
      url === "bigficradisclosure/blankdisclosure"
    ) {
      let headers = getHeaders(token, isPDF);
      // Remove Content-Type if uploading FormData
      if (typeof FormData !== "undefined" && data instanceof FormData) {
        headers = { ...headers };
        delete headers["Content-Type"];
      }
      if (!responseType) {
        res = await axios({
          method,
          url: isUBIQ ? getUBIQUrl(url) : getUrl(url, isContractURL),
          headers,
          data: data,
        });
      } else {
        res = await axios({
          method,
          url: isUBIQ ? getUBIQUrl(url) : getUrl(url, isContractURL),
          responseType,
          headers,
          data: data,
        });
      }

      return res;
    }

    res = await axios({
      method,
      url: isUBIQ ? getUBIQUrl(url) : getUrl(url, isContractURL),
      headers: getHeaders(token, isPDF),
      ...(responseType ? { responseType } : {}),
    });

    return res;
  } catch (error) {
    console.error(error);

    logError(error);

    if (isErrorPage) {
      window.location = "./errorPage";
    }
  }
};
